import { Pagination } from '@ui/src';

export enum WriteOffType {
  PERCENT_OF_BALANCE = 'Percent of balance',
  FIXED_VALUE = 'Fixed value',
}

export enum WriteOffFeeCurrency {
  IN_FEE_CURRENCY = 'In Fee currency',
  IN_TRANSACTION_CURRENCY = 'In Transaction currency',
}

export enum FeeStatus {
  ACTIVE = 'Active',
  INACTIVE = 'Inactive',
  ARCHIVE = 'Archive',
}

export enum TariffLogTypeEnum {
  CHANGED_TARIFF = 'CHANGED_TARIFF',
  CHANGED_WRITE_OFF_TYPE = 'CHANGED_WRITE_OFF_TYPE',
  SET_WRITE_OFF_VALUE = 'SET_WRITE_OFF_VALUE',
  CHANGED_WRITE_OFF_VALUE = 'CHANGED_WRITE_OFF_VALUE',
}

export interface FeeLog {
  id: string;
  type: TariffLogTypeEnum;
  from?: string;
  to?: string;
  value?: string;
  isModified?: boolean;
  user: {
    firstName: string;
    lastName: string;
  };
  date: string;
}

export enum FeeAmountTypeEnum {
  FIXED = 'FIXED',
  PERCENT = 'PERCENT',
}

export interface FeeItemFeeType {
  id: string;
  feeTargetAccountNumber: string;
  feeType: string;
  name: string;
}

export interface FeeItem {
  feeAmountType: string;
  feeFixedAmount: number;
  feeId: string;
  feePercentAmount: number;
  feePercentMaxAmount: number;
  feePercentMinAmount: number;
  feeTargetAccountNumber: string;
  feeCascadeCurrenciesIds?: string[];
  feeCurrencyId?: string;
  id: string;
  name: string;
  tariffId: string;
  fee: FeeItemFeeType;
  updatedAt: string;
  currency?: string;
  writeOffValue?: string;
  isModified?: boolean;
  url?: string;
  render?: Record<string, React.JSX.Element>;
}
export interface Tariff {
  name: string;
  riskScoreRangeId: string;
  id: string;
}

export interface TariffFee {
  isLoading: boolean;
  requestInProgress: boolean;
  selectedFees: string[];
  sort?: {
    sortProp: string;
    sortDir: string;
  };
  selectedArchiveFees: string[];
  deleteInProgress?: boolean;
  deleteSuccess?: boolean;
  restoreInProgress?: boolean;
  restoreSuccess?: boolean;
}

export interface ChangeTariffPanelTypes {
  isLoading?: boolean;
  tariffsList?: Tariff[];
  setSelectedTariffId: (data: string) => void;
  selectedTariffId?: string;
  type: 'INDIVIDUAL' | 'CORPORATE';
  panelIsOpen: boolean;
  handleClose: () => void;
  tariffChangeInProgress?: boolean;
  assignTariffToCustomerAction: () => void;
  searchValue?: string;
}

export interface MarginAmount {
  defaultMarginId?: string;
  marginId?: string;
  fromAmount: number;
  feePercent: number;
  id?: string;
}

export interface CustomMargin {
  rateSourceId: string;
  defaultMarginId: string;
  currencyFromId: string;
  riskScoreRangeId?: string;
  organizationId?: string;
  url?: string;
  currencyFrom: {
    name: string;
  };
  currencyToId: string;
  currencyTo: {
    name: string;
  };
  tariffId: string;
  tariff: {
    name: string;
    riskScoreRangeId: string;
  };
  isCustom: boolean;
  targetAccountGainsId: string;
  targetAccountLossesId: string;
  rateSource: {
    name: string;
    description: string;
    id: string;
  };
  id: string;
  amounts?: {
    edges: {
      node: MarginAmount;
    }[];
  };
  render?: Record<string, React.JSX.Element>;
}

export interface MarginFormValues {
  targetAccountGainsId: string;
  targetAccountLossesId: string;
  rateSourceId?: string;
  amounts: MarginAmount[];
  currencyFromId?: string;
  currencyToId?: string;
  tariffId?: string | null;
  organizationId?: string;
  defaultMarginId?: string;
}

export interface CustomMarginsTypes {
  showMoreCurrencies?: boolean;
  menuOnFocus: boolean;
  setShowMoreCurrencies: (data: boolean) => void;
  defaultMargin?: CustomMargin;
  tariffId?: string;
  allMarginsVisible?: boolean;
  customerId?: string;
  customMargins?: CustomMargin[];
  setAllMarginsVisible: (data: boolean) => void;
  setSelectedCurrency: (data: string) => void;
  selectedCurrency?: string;
  setMenuOnFocus: (data: boolean) => void;
  type: 'INDIVIDUAL' | 'CORPORATE';
  customMarginsPagination?: Pagination;
  setSeletedMarginId: (data: string) => void;
  setMarginPanelIsOpen: (data: boolean) => void;
  customMarginsErrorsList?: string;
}

export interface MarginDetailsTypes {
  setPanelIsOpen: (data: boolean) => void;
  customerId?: string;
  defaultMargin?: CustomMargin;
  allMarginsVisible?: boolean;
  selectedCurrency?: string;
  tariffId?: string;
  panelIsOpen: boolean;
  selectedMarginId?: string;
  status: string;
}
